/* src/app/private/components/registration/delete-registration/delete-registration.component.scss */
/*# sourceMappingURL=delete-registration.component.css.map */
